import TelegramSvg from "./telegram.svg"
import DiscordSvg from "./discord.svg"
import PawSvg from "./paw.svg"
import TwitterXSvg from "./twitter-x.svg"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

export default function SocialGroupLinkButton({ type }) {

    const [data, setData] = useState(null);

    useEffect(() => {
        switch (type) {
            case 'telegram':
                setData({
                    name: "Telegram",
                    link: "https://t.me/+LPKHccQiNR03ZDQ7",
                    img: TelegramSvg,
                    bgc: "#26a2e0"
                });
                break;
            case 'discord':
                setData({
                    name: "Discord",
                    link: "https://discord.gg/nXGUjUpXQG",
                    img: DiscordSvg,
                    bgc: "#5662f6"
                });
                break;
            case 'furaffinity':
                setData({
                    name: "FurAffinity",
                    link: "https://www.furaffinity.net/user/socalfurs",
                    img: PawSvg,
                    bgc: "#f69608"
                });
                break;
            case 'twitter':
                setData({
                    name: "Twitter / X",
                    link: "https://twitter.com/socal_furs",
                    img: TwitterXSvg,
                    bgc: "#000"
                });
                break;
            case 'map':
                setData({
                    name: "Map",
                    link: "https://socalfurs.com/events/map",
                    img: PawSvg,
                    bgc: "#f69608"
                });
        }
    }, [type])

    if (data === null) return;

    return (
        <Link to={data.link} style={{textDecoration: 'none'}}>
            <button
                style={{
                    border: 'none',
                    backgroundColor: data.bgc,
                    color: 'white',
                    padding: '8px 12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 8,
                    width: 125
                }}
            >
                <img src={data.img} style={{filter: "invert(100%)", width: 18}} />
                <span>{data.name}</span>
            </button>
        </Link>
    )
}
